import { extend, setInteractionMode } from 'vee-validate';
import { required, email, min_value, max_value } from 'vee-validate/dist/rules';
import i18n from './i18n/i18n-config';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: values => i18n.t('validation.required', { '_field_': values }),
});

extend('email', {
  ...email,
  message: (fieldName) => i18n.t('validation.email', { '_field_': fieldName }),
});

extend('min_value', {
  ...min_value,
  message: (fieldName, { min }) => i18n.t('validation.min_value', { '_field_': fieldName, min }),
});

extend('max_value', {
  ...max_value,
  message: (fieldName, { max }) => i18n.t('validation.max_value', { '_field_': fieldName, max }),
});
